<template>
  <div class="space-y-2">
    <div class="flex items-center gap-2">
      <ConfigHelpLabel label="高度" help-key="block_spacer_height" label-class="text-[10px] text-gray-500 w-10" tag="span" />
      <input type="range" v-model.number="block.data.height" min="4" max="80" step="2" class="flex-1 h-1 accent-blue-600" @input="$emit('update')" />
      <span class="text-[10px] text-gray-400 w-8 text-right">{{ block.data.height }}px</span>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String] })
defineEmits(['update'])
onMounted(() => { if (!props.block.data) props.block.data = { height: 20 }; if (!props.block.data.height) props.block.data.height = 20 })
</script>
